import React from 'react';
import classNames from 'classnames';

import { Icon } from '@eb/eds-icon';
import { Trending as TrendingSvg } from '@eb/eds-iconography';

const TrendingSearchesAnchor = ({
    trendingSearchData,
    containerClassNames = [],
}) => {
    let component = null;

    if (trendingSearchData) {
        const trendingSearchesAnchorClasses = classNames(
            'search-footer__trending-searches',
            'eds-align--center',
            ...containerClassNames,
        );

        component = (
            <div className={trendingSearchesAnchorClasses}>
                <a
                    href={trendingSearchData.path}
                    className="eds-text-weight--heavy eds-align--center"
                >
                    <span className="eds-l-mar-right-3">
                        <Icon type={<TrendingSvg />} />
                    </span>
                    {trendingSearchData.text}
                </a>
            </div>
        );
    }

    return component;
};

export default TrendingSearchesAnchor;
